
<section 
mouseWheel
(mouseWheelUp)="mouseWheelUpFunc($event)"
(mouseWheelDown)="mouseWheelDownFunc($event)"
class="transition-2 d-block" [ngClass]="{'overflow-hidden': screenWidth <= 1024}" [ngStyle]="{'height':screenHeight + 'px'}">
    <div *ngIf="modules"
        #gridcontainer
        [ngStyle]="{'transform': 'translateY(' + counter + 'px)', '-webkit-transform': 'translateY(' + counter + 'px)', '-moz-transform': 'translateY(' + counter + 'px)','-o-transform': 'translateY(' + counter + 'px)'}" 
        (scroll)="onScroll($event)"
        class="company-container transition-grid" [ngClass]="{'prevent-animation':stopScrollAnimation}">
        
        <div id="compnay-container-{{i}}" class="compnay-container-module  scroll-snap-align-start" *ngFor="let module of modules.acf.modules; let i = index;">
            <app-company-item #itemcomponent [module]="module" [i]="i"></app-company-item>
        </div>
        <div class="w-100 H-100-full  H-auto-tablet overflow-hidden" [ngClass]="{'scroll-snap-align-start':modules}">
            <app-footer></app-footer>
        </div>
        <div *ngIf="screenWidth <= 1024 && screenWidth > 768" id="dots-wrapper" class="vertical-dots-wrapper dark-dots">
            <a id="gallery-dot-{{j}}" class="gallery-dots"
            *ngFor="let dots of modules.acf.modules; let j = index"
            (click)="scrollItem(j)">
                <div class="dots-inner-wrapper"></div>
            </a>
        </div>
    </div>
    <div *ngIf="screenWidth > 767" class="d-none d-lg-block fade-overlay-menu" [ngClass]="{'active': activateMenuOverlay}"></div>
</section>
